import React, { useEffect, useState } from 'react';
import { FiAward, FiTrendingUp } from 'react-icons/fi';
import AdminShell from '../../components/AdminShell/AdminShell';
import PageHeader from '../../components/PageHeader/PageHeader';
import { useCurrency } from '../../app/CurrencyContext';
import AdminWalletBadge from '../../components/AdminWalletBadge/AdminWalletBadge';
import panelStyles from '../../styles/adminPanels.module.css';
import styles from './AdminContest.module.css';
import axiosClient from '../../api/axiosClient';

interface Row {
  userId: string; fullName: string; email: string; directCount: number; totalBusiness: number;
  tier: { pct: number; label: string } | null;
  prize: string | null;
}

const AdminContest: React.FC = () => {
  const { formatFromInr } = useCurrency();
  const [rows, setRows] = useState<Row[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosClient.get('/admin/contest').then(({ data }) => setRows(data.rows)).finally(() => setLoading(false));
  }, []);

  return (
    <AdminShell>
      <PageHeader title="Contest & Prizes" subtitle="Cr business milestones and the 5-directs bonus tiers." action={<AdminWalletBadge />} />

      <div className={panelStyles.page}>
        <div className={styles.milestoneGrid}>
          <div className={styles.milestoneCard}>
            <FiAward className={styles.milestoneIcon} />
            <div>
              <span>Cr 1 in 90 days</span>
              <b>Maruti Fronx</b>
            </div>
          </div>
          <div className={styles.milestoneCard}>
            <FiAward className={styles.milestoneIcon} />
            <div>
              <span>Cr 5 in 90 days</span>
              <b>Skoda Slavia</b>
            </div>
          </div>
        </div>

        <div className={panelStyles.tableWrap}>
          {loading && <div className={panelStyles.loading}><span className={panelStyles.spinnerLg} /></div>}
          {!loading && rows.length === 0 && <div className={panelStyles.empty}>No qualifying network business yet.</div>}
          {!loading && rows.length > 0 && (
            <table className={panelStyles.table}>
              <thead><tr><th>User</th><th>Direct Referrals</th><th>Total Business</th><th>Bonus Tier</th><th>Prize Milestone</th></tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.userId}>
                    <td><div className={panelStyles.nameCell}>{r.fullName}</div><div className={panelStyles.subCell}>{r.email}</div></td>
                    <td>{r.directCount}</td>
                    <td className={panelStyles.nameCell}>{formatFromInr(r.totalBusiness)}</td>
                    <td>
                      {r.tier ? (
                        <span className={panelStyles.statusPill} style={{ color: '#a855f7', borderColor: '#a855f7' }}>
                          {r.tier.pct}% — {r.tier.label}
                        </span>
                      ) : <span className={panelStyles.subCell}>Not yet qualified</span>}
                    </td>
                    <td>
                      {r.prize ? (
                        <span className={styles.prizeBadge}><FiTrendingUp /> {r.prize}</span>
                      ) : <span className={panelStyles.subCell}>—</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </AdminShell>
  );
};

export default AdminContest;
